import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import _ from 'lodash';
import { Dollars } from 'barnyard/components';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import OrderAlertTable from './OrderAlertTable';


const PercentBudgetSpentAlert = ({ alert, ...other }) => {
  const alertTypeLabel = _.get(alert, ['value', 'alert_type']);
  const budgetMessage = alertTypeLabel ? `${alertTypeLabel} budgeted` : 'budgeted';
  const orders = _.get(alert, ['value', 'orders']);
  const invoices = _.get(alert, ['value', 'invoices']);
  return (
    <AlertItem
      alert={alert}
      date={moment(alert.date).format('MMMM Do, YYYY')}
      icon={<BarnyardIcon icon={['fa', 'balance-scale-right']} className='DiscussCard__replyIcon budget' />}
      title={(
        <div>
          <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
            {alert.buyer.name}
          </Link>
          {' '} spent {' '} 
          <strong className='color-warning'>
            <Dollars integer={alert.value.spend} includeCents={true} />{' '}({alert.value.percent_spent}%)
          </strong>
          {' '} which is at least {' '}
          <strong className='color-warning'>{alert.value.percent}%</strong>
          {' '} of the {' '} {budgetMessage} {' '} amount of {' '}
          <strong className='color-primary'>
            <Dollars integer={alert.value.budget} includeCents={true} />
          </strong>.
        </div>
      )}
      content={(
        <OrderAlertTable
          includeExport={true}
          orders={_.isEmpty(orders) ? invoices : orders}
          type={_.isEmpty(orders) ? 'invoice' : 'order'}
        />
      )}
      {...other}
    />
  );
};

PercentBudgetSpentAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default PercentBudgetSpentAlert;
